<div class="card-pharmacy grid grid-cols-1 md:grid-cols-2 gap-4 bg-white rounded-xl p-4 items-top md:min-h-[220px]">
  <!-- Infos principales -->
  <div class="flex flex-col gap-2">
    <h5 class="!font-medium text-gray-600">
      {{ pharmacy.name }}
    </h5>

    <!-- Prestataire Connecté indicator -->
    @if (pharmacy.eyoneUser) {
    <div class="flex items-center gap-1"
      [title]="'Ce prestataire échange automatiquement vos informations avec votre {{getProductName()}} pour faciliter votre prise en charge.'">
      <span class="bg-green-100 text-green-700 text-xs font-semibold px-2 py-1 rounded flex items-center gap-1">
        <lucide-icon [img]="CircleIcon" [size]="10" class="fill-green-500 text-green-500"></lucide-icon>
        Prestataire Connecté
      </span>
    </div>
    }

    @if (pharmacy?.coordonate?.globalAddressField) {
    <div>
      <p class="text-gray-500 text-sm">
        {{ pharmacy.coordonate.globalAddressField }}
      </p>
      @if (pharmacy?.distance != null) {
      <span class="flex items-center gap-x-1 text-xs text-gray-400 mt-1">
        <lucide-icon class="text-primary" [img]="MapPinIcon" [size]="14"></lucide-icon>
        <span class="text-primary">{{ roundDistance(pharmacy.distance) }}</span>
      </span>
      }
    </div>
    }

    <div class="flex items-center gap-2">
      <lucide-icon [img]="PhoneIcon" color="gray" [size]="14"></lucide-icon>
      <span class="text-gray-600 text-sm">
        @if (pharmacy.coordonate?.mobileNumber) {
        {{ pharmacy.coordonate.mobileNumber }}
        } @if (pharmacy.coordonate?.mobileNumber &&
        pharmacy.coordonate?.fixNumber) { &nbsp;/&nbsp; } @if
        (pharmacy.coordonate?.fixNumber) {
        {{ pharmacy.coordonate.fixNumber }}
        }
      </span>
    </div>

    <div class="flex flex-wrap gap-2 mt-1">
      <span *ngFor="let payment of pharmacy.paymentTypes"
        class="bg-blue-100 text-blue-800 px-3 py-1 rounded-lg text-xs font-semibold">{{ payment.name }}</span>
    </div>

    <!-- Add availability information -->
    <div class="flex flex-col gap-1.5 mt-2">
      <div class="flex items-center gap-2">
        <lucide-icon [img]="ClockIcon" color="gray" [size]="14"></lucide-icon>
        <span class="text-gray-600 text-[13px]">
          {{ pharmacy.openingTH ? "Ouvert 24H/24" : "Horaires standards" }}
        </span>
      </div>
      <div class="flex items-center gap-2">
        <lucide-icon [img]="CalendarIcon" color="gray" [size]="14"></lucide-icon>
        <span class="text-gray-600 text-[13px]">
          {{
          pharmacy.openSunday ? "Ouvert les dimanches" : "Fermé les dimanches"
          }}
        </span>
      </div>
    </div>

    <button [routerLink]="[PrefixUrlCountryCode, 'pharmacies', pharmacy.id]"
      class="btn btn-sm w-fit bg-[#232c7c] text-white rounded-full text-sm hover:bg-[#232c7c]-dark transition-colors">
      <span class="flex items-center gap-x-2"> Voir les détails </span>
    </button>
  </div>
  <!-- Carte Google Maps -->
  <div class="rounded-lg overflow-hidden w-full h-40 min-h-[160px] md:h-full flex">
    <app-safe-maps [latitude]="pharmacy.coordonate?.latitude ?? 0" [longitude]="pharmacy.coordonate?.longitude ?? 0"
      [zoom]="15" height="100%" style="width: 100%; height: 100%">
    </app-safe-maps>
  </div>
</div>